import { readCustomFieldColors } from './read'

export const customFieldColors = {
  readCollection: readCustomFieldColors,
}
